export const removeEmptyObjectValues = (obj = {}) => {
  const out = {};
  Object.keys(obj).forEach((key) => {
    const val = obj[key];
    if (val !== null && val !== undefined) {
      out[key] = val;
    }
  });
  return out;
};
